import { useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
import { tablesActions, tablesSelectors } from '../../../../../../actions';
import {
    RootState,
    useAppDispatch,
    useAppSelector,
} from '../../../../../base-redux';
import { Control, UseFormGetValues, useWatch } from 'react-hook-form';
import {
    ITableForm,
    TableFormValues,
    getBasicColorsObject,
} from '../../../../../../common';
import { useTheme } from '../../../../../base-components';
const useDebouncedSearch = (
    getValues: UseFormGetValues<ITableForm>,
    control: Control<ITableForm>
) => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const baseColors = getBasicColorsObject(theme.palette);

    const searchValue = useWatch({
        control,
        name: TableFormValues.search,
    });

    const tableState = useAppSelector((state: RootState) =>
        tablesSelectors.getTablesState(
            state,
            getValues(TableFormValues.tableId)
        )
    );

    const debouncedSearch = useCallback(
        debounce(() => {
            const formData = getValues();
            if (!tableState.initialLoad) {
                dispatch(
                    tablesActions.fetchTableDataById({
                        tableId: formData.tableId,
                        formData,
                        page: 1,
                        baseColors,
                    })
                );
            }
        }, 300),
        [dispatch, getValues, tableState.initialLoad]
    );

    useEffect(() => {
        debouncedSearch();
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch, searchValue]);
};

export default useDebouncedSearch;
